// import { injectMocks } from '@jfs/network'
import { UiThemeProvider } from '@jfs/ui-new'
import { RootStore, StoreProvider } from './data/store'
// import { mocks } from './mocks'
import JSEncrypt from 'jsencrypt'
import { LogBox } from 'react-native'
import { AppStack } from './nav/RootNav'
import { customTheme, isMobile, useWindowDimensions } from './util/util'

// const isDataMock = true
export const App = (props) => {
  try {
    LogBox.ignoreAllLogs(true)
  } catch (error) {
    console.log('Warnings enabled')
  }

  // if (isDataMock) {
  //   injectMocks(mocks, 'default', {
  //     allowXHRPassthrough: true,
  //     allowFetchPassthrough: true,
  //   })
  // }
  console.log('JSEncrypt', new JSEncrypt())
  const viewPortWidth = useWindowDimensions()
  return (
    <StoreProvider value={RootStore}>
      <UiThemeProvider
        initialThemeName={'newThemeLight'}
        customTheme={{
          name: 'mportalLight',
          extraTheme: isMobile(viewPortWidth > 550) ? customTheme : {},
          extends: 'light',
        }}>
        <AppStack {...props} />
      </UiThemeProvider>
    </StoreProvider>
  )
}
